import * as React from 'react'

function SvgOfficeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.485 51.333H4.667V4.667H35v15.555"
        stroke="currentColor"
        strokeWidth={1.6}
      />
      <path
        d="M14 11.667v4.666M26 12v4.667M14 21v4.667M14 30.333V35M14 39.667v4.666M32.667 37.333V42M32.667 28v4.667M41 28v4.667"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M25.667 21H49v30.333H25.667V21z"
        stroke="currentColor"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgOfficeIcon
